import { optionsToMap } from '@/utils/common';

import { Option } from './option';

/** 权限类型枚举 */
export enum AuthType {
  /** 初级 */
  Low = 1,
  /** 中级 */
  Middle = 2,
  /** 高级 */
  High = 3,
}

/** 权限类型选项 */
export const authTypes: Option<AuthType>[] = [
  { value: AuthType.Low, label: '初级' },
  { value: AuthType.Middle, label: '中级' },
  { value: AuthType.High, label: '高级' },
];

/** 权限类型文本 */
export const authTypeTexts = optionsToMap(authTypes);
